<template>
  <div>
    <v-textarea
      v-model="message"
      :maxLength="maxLength"
      outlined
      placeholder="Mon message..."
      no-resize
      hide-details=""
    >
    </v-textarea>
    <div class="counter pt-2" v-show="hasCharactersRemaining">
      {{ totalCharacters }}/{{ maxLength }} caractères.
    </div>
    <div
      :class="{ 'max-counter': !hasCharactersRemaining }"
      v-show="!hasCharactersRemaining"
    >
      Limite de caractères atteinte.
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      maxLength: 150,
    };
  },

  computed: {
    totalCharacters() {
      return this.message.length;
    },
    hasCharactersRemaining() {
      return this.totalCharacters < this.maxLength;
    },
    message: {
      set(message) {
        this.$emit("input", message);
      },
      get() {
        return this.value;
      },
    },
  },
};
</script>

<style lang="scss">
.max-counter {
  color: red;
}

.counter {
  color: $color-white-dark;
  font-weight: bold;
}
</style>         